import { db } from "common/config/Firebase";

const notesCollection = db.collection("notes");

const deleteNoteUseCase = async (id) => {
  await notesCollection.doc(id).delete();
};

export default deleteNoteUseCase;